import { useAuthAdminStore } from '@/stores/AuthAdminStore'
import { computed } from 'vue'
import { useWebSocket } from '@vueuse/core'
import { Notification } from '@/plugins/notifications'
import { eventActionBus } from './EventActionBus'

class WebsocketManager {

  constructor() {
		this.connections = new Map() // Armazena conexões por grupo (ex: 'notifications', 'layout')
	}

  /**
	 * Conecta (ou retorna conexão existente) para um grupo
	 * @param {string} conectionName - Nome do grupo (ex: 'notifications', 'layout')
	 * @param {string} path - Caminho do websocket (ex: 'ws/notifications/')
	 */
  connect(conectionName, path) {
    if (this.connections.has(conectionName)) {
			console.log(`[WebSocketManager] Reutilizando conexão existente para grupo: ${conectionName}`)
			return this.connections.get(conectionName)
		}
    console.log(`[WebSocketManager] Criando nova conexão WebSocket para grupo: ${conectionName}`)

    const authStore = useAuthAdminStore()

    const fullWsUrl = computed(() => {
			const baseUrl = (import.meta.env.VITE_WS_URL || 'ws://localhost:8000/') + path
			const token = authStore.token
      let queryParams = `?owner-url=${window.location.host}`

			if (token) {
        queryParams += `&token=${token}`
      }
      return `${baseUrl}${queryParams}`
		})

    const { status, send, close } = useWebSocket(fullWsUrl, {
			autoReconnect: {
				retries: 3,
				delay: 1000,
				onFailed() {
					Notification.error('Falha ao conectar com o servidor WebSocket.')
				},
			},
      onConnected() {
        console.log(`[WebSocketManager] ✅ Conectado ao grupo: ${conectionName}`)
      },
      onDisconnected() {
        console.warn(`[WebSocketManager] ⚠️ Desconectado do grupo: ${conectionName}`)
      },
      onMessage(_, event) {
        try {
          const message = JSON.parse(event.data)
          console.log(`[WebSocketManager:${conectionName}] Mensagem recebida:`, message)

          if (message?.message) {
            Notification[message.notify_type || 'info'](message.message)
          }

          if (message?.action) {
            // websocketActionBus.emit(message.action, message.data)
            eventActionBus.emit(conectionName, message.action, message.data)
          }
        } catch (error) {
          console.error('[WebSocketManager] Erro ao analisar mensagem:', error)
        }
      },
      onError(_, error) {
        console.error(`[WebSocketManager] ❌ Erro no WebSocket (${conectionName}):`, error)
        // Notification.error('Erro na conexão WebSocket.')
      },
		})

		const cleanup = () => {
			close()
			this.connections.delete(conectionName)
			console.log(`[WebSocketManager] Conexão encerrada para grupo: ${conectionName}`)
		}

		const connection = { status, send, close, cleanup, path }
		this.connections.set(conectionName, connection)

		return connection
  }

  /**
	 * Desconecta de um grupo específico
	 */
	disconnect(conectionName) {
		const conn = this.connections.get(conectionName)
		if (conn) {
			conn.cleanup()
		}
	}

  /**
	 * Envia uma mensagem para um grupo específico
	 */
	send(conectionName, payload) {
		const conn = this.connections.get(conectionName)
		if (!conn) {
			console.warn(`[WebSocketManager] Nenhuma conexão ativa para grupo: ${conectionName}`)
		}

    try {
      conn.send(JSON.stringify(payload))
    } catch (err) {
      console.error(`[WebSocketManager] Erro ao enviar mensagem (${conectionName}):`, err)
    }
	}

	/**
	 * Desconecta todas as conexões
	 */
	disconnectAll() {
		this.connections.forEach(conn => conn.cleanup())
		this.connections.clear()
		console.log("[WebSocketManager] Todas as conexões encerradas")
	}
}

export const websocketManager = new WebsocketManager()